import { render, staticRenderFns } from "./SjChildrenListWindow.vue?vue&type=template&id=822d7b6e&scoped=true&"
import script from "./SjChildrenListWindow.vue?vue&type=script&lang=js&"
export * from "./SjChildrenListWindow.vue?vue&type=script&lang=js&"
import style0 from "./SjChildrenListWindow.vue?vue&type=style&index=0&id=822d7b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822d7b6e",
  null
  
)

export default component.exports